import Vue from 'vue';
import Vuex from 'vuex';
import breadcrumb from './modules/breadcrumb';
import env from './modules/env';
import auth from './modules/auth';
import province from './modules/province';
import tournament from './modules/tournament';
import certification from './modules/certification';
import agency from './modules/agency';
import exam from './modules/exam';
import event from './modules/event';
import aiGame from './modules/aiGame';
import popupRecord from './modules/popupRecord';

const modules = {
  breadcrumb,
  env,
  auth,
  province,
  tournament,
  agency,
  exam,
  event,
  aiGame,
  certification,
  popupRecord,
};

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
});
